(function () {
  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root
      : "/";
  }

  function currencyCode() {
    return (
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.currency) ||
      document.documentElement.getAttribute("data-shopify-currency") ||
      "USD"
    );
  }

  function formatMoney(cents) {
    const code = currencyCode();
    const amount = cents / 100;
    try {
      const formatted = new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: code,
        currencyDisplay: "narrowSymbol",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
      return `${code} ${formatted}`;
    } catch (e) {
      return `${code} ${amount.toFixed(2)}`;
    }
  }

  function normalizePath(p) {
    if (!p) return "";
    p = String(p).trim();

    // Allow full URLs or paths
    try {
      if (p.startsWith("http://") || p.startsWith("https://")) p = new URL(p).pathname;
    } catch (e) {}

    // strip query/hash + trailing slashes
    p = p.split("?")[0].split("#")[0].replace(/\/+$/, "");

    if (!p.startsWith("/")) p = "/" + p;
    return p;
  }

  function extractHandleFromPath(path) {
    const m = String(path || "").match(/\/products\/([^\/\?]+)/i);
    return m && m[1] ? m[1] : null;
  }

  /**
   * --- Weglot subdirectory support ---
   * If Weglot is running in subdirectory mode, translated pages are typically /fr/..., /de/...
   * Our JS-created links must keep that prefix.
   *
   * Uses Weglot.getCurrentLang() and Weglot.options.language_from when available. :contentReference[oaicite:1]{index=1}
   */
  function weglotPrefix() {
    try {
      if (!window.Weglot) return "";
      if (!window.Weglot.getCurrentLang) return "";

      const current = window.Weglot.getCurrentLang();
      const from = window.Weglot.options && window.Weglot.options.language_from;

      // If we can't detect default language reliably, be conservative:
      // if current exists and the URL already includes a 2-letter prefix, we keep it via localizePath().
      if (!current) return "";

      // If current is default language, prefix should be empty.
      if (from && current === from) return "";

      return "/" + current;
    } catch (e) {
      return "";
    }
  }

  function localizePath(pathLike) {
    let p = normalizePath(pathLike);
    if (!p) return p;

    const prefix = weglotPrefix();
    if (!prefix) return p;

    // Already localized (e.g. "/fr/products/..." or "/fr/collections/...") -> keep
    if (p === prefix || p.startsWith(prefix + "/")) return p;

    // Do not localize non-site links
    // (we only expect internal paths here; normalizePath already forces "/")
    return prefix + p;
  }

  // Cache across all sections
  const productCache = new Map();

  async function fetchProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    const res = await fetch(`${shopRoot()}products/${handle}.js`, { credentials: "same-origin" });
    if (!res.ok) throw new Error("Fetch failed");
    const p = await res.json();
    productCache.set(handle, p);
    return p;
  }

  function loadImageWithPlaceholder(imgEl, phEl, url, alt) {
    if (!imgEl || !phEl) return;
    imgEl.hidden = true;
    phEl.hidden = false;
    imgEl.removeAttribute("src");
    imgEl.alt = alt || "";

    if (!url) return;

    const pre = new Image();
    pre.onload = function () {
      imgEl.src = url;
      imgEl.alt = alt || "";
      imgEl.hidden = false;
      phEl.hidden = true;
    };
    pre.onerror = function () {
      imgEl.hidden = true;
      phEl.hidden = false;
    };
    pre.src = url;
  }

  function getSectionEls(section) {
    return {
      wrap: section.querySelector(".stl__imageWrap"),
      overlay: section.querySelector(".stl__overlay"),
      drawer: section.querySelector(".stl__drawer"),
      closeBtn: section.querySelector(".stl__close"),
      continueBtn: section.querySelector(".stl__continue"),

      status: section.querySelector(".stl__status"),
      unavailable: section.querySelector(".stl__unavailable"),

      mainWrap: section.querySelector(".stl__productMain"),
      imgLink: section.querySelector(".stl__imgLink"),
      imgEl: section.querySelector(".stl__prodImgEl"),
      imgPh: section.querySelector(".stl__imgPh"),
      titleEl: section.querySelector(".stl__title"),
      priceEl: section.querySelector(".stl__price"),
      viewLink: section.querySelector(".stl__view"),

      alsoWrap: section.querySelector(".stl__also"),
      alsoList: section.querySelector(".stl__alsoList"),
    };
  }

  function resetSectionUI(els) {
    if (els.mainWrap) els.mainWrap.hidden = true;
    if (els.status) els.status.hidden = true;
    if (els.unavailable) els.unavailable.hidden = true;

    if (els.titleEl) els.titleEl.textContent = "";
    if (els.priceEl) els.priceEl.textContent = "";

    if (els.imgEl) {
      els.imgEl.hidden = true;
      els.imgEl.removeAttribute("src");
      els.imgEl.alt = "";
    }
    if (els.imgPh) els.imgPh.hidden = false;

    if (els.viewLink) els.viewLink.href = "#";
    if (els.imgLink) els.imgLink.href = "#";

    if (els.alsoWrap) els.alsoWrap.hidden = true;
    if (els.alsoList) els.alsoList.innerHTML = "";
  }

  function openDrawer(els) {
    if (!els.overlay || !els.drawer) return;
    els.overlay.hidden = false;
    els.drawer.classList.add("is-open");
    els.drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function closeDrawer(els) {
    if (!els.overlay || !els.drawer) return;
    els.overlay.hidden = true;
    els.drawer.classList.remove("is-open");
    els.drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    resetSectionUI(els);
  }

  function getAllPathsInSection(section) {
    const paths = [];
    section.querySelectorAll(".stl__hotspot[data-path]").forEach((b) => {
      const p = normalizePath(b.getAttribute("data-path"));
      if (p && !paths.includes(p)) paths.push(p);
    });
    return paths;
  }

  function miniItemHTML(p, path) {
    const img = p.featured_image || (p.images && p.images[0]) || "";
    const priceCents = p.variants && p.variants[0] ? p.variants[0].price : null;
    const title = p.title || "";

    // IMPORTANT: preserve Weglot subdirectory
    const url = localizePath(path) || localizePath(p.url) || "#";

    return `
      <div class="stl__mini">
        <a class="stl__miniImgWrap" href="${url}">
          <img class="stl__miniImg" src="${img}" alt="${title.replace(/"/g, "&quot;")}" loading="lazy" />
        </a>
        <div>
          <div class="stl__miniTitle">${title}</div>
          <div class="stl__miniPrice">${priceCents != null ? formatMoney(priceCents) : ""}</div>
        </div>
        <a class="stl__miniBtn" href="${url}">View</a>
      </div>
    `;
  }

  async function renderProductIntoDrawer(section, path) {
    const els = getSectionEls(section);
    resetSectionUI(els);

    if (els.status) {
      els.status.textContent = "Loading product…";
      els.status.hidden = false;
    }

    const fullPath = normalizePath(path);
    const handle = extractHandleFromPath(fullPath);

    if (!handle) {
      if (els.status) els.status.hidden = true;
      if (els.unavailable) els.unavailable.hidden = false;
      return;
    }

    try {
      const p = await fetchProduct(handle);

      const img = p.featured_image || (p.images && p.images[0]) || "";
      const priceCents = p.variants && p.variants[0] ? p.variants[0].price : null;
      const title = p.title || "";

      // IMPORTANT: preserve Weglot subdirectory, but keep the original “collection context” path if provided
      const url = localizePath(fullPath) || localizePath(p.url) || "#";

      if (els.status) els.status.hidden = true;

      if (els.titleEl) els.titleEl.textContent = title;
      if (els.priceEl) els.priceEl.textContent = (priceCents != null) ? formatMoney(priceCents) : "";

      if (els.viewLink) els.viewLink.href = url;
      if (els.imgLink) els.imgLink.href = url;

      loadImageWithPlaceholder(els.imgEl, els.imgPh, img, title);

      if (els.mainWrap) els.mainWrap.hidden = false;

      // Also on this look
      const allPaths = getAllPathsInSection(section);
      const others = allPaths.filter((p2) => normalizePath(p2) !== fullPath);

      if (els.alsoWrap && els.alsoList && others.length) {
        els.alsoWrap.hidden = false;

        const jobs = others.map(async (p2) => {
          const h2 = extractHandleFromPath(p2);
          if (!h2) return null;
          const prod2 = await fetchProduct(h2);
          return { prod2, p2 };
        });

        const results = await Promise.allSettled(jobs);
        els.alsoList.innerHTML = results
          .filter(r => r.status === "fulfilled" && r.value)
          .map(r => miniItemHTML(r.value.prod2, r.value.p2))
          .join("");
      }
    } catch (e) {
      if (els.status) els.status.hidden = true;
      if (els.unavailable) els.unavailable.hidden = false;
    }
  }

  function applyHotspotColors(section) {
    section.querySelectorAll(".stl__hotspot[data-color]").forEach((b) => {
      const c = b.getAttribute("data-color");
      if (c) b.style.setProperty("background", c, "important");
    });
  }

  // Bind per section (survives Builder async rendering)
  function bind() {
    document.querySelectorAll(".stl").forEach((section) => {
      if (section.dataset.stlBound === "1") return;
      section.dataset.stlBound = "1";

      applyHotspotColors(section);

      const els = getSectionEls(section);
      if (els.overlay) els.overlay.addEventListener("click", () => closeDrawer(els));
      if (els.closeBtn) els.closeBtn.addEventListener("click", () => closeDrawer(els));
      if (els.continueBtn) els.continueBtn.addEventListener("click", () => closeDrawer(els));
    });
  }

  // Hotspot clicks (delegated)
  document.addEventListener("click", function (e) {
    const hotspot = e.target.closest(".stl__hotspot");
    if (!hotspot) return;

    const section = hotspot.closest(".stl");
    if (!section) return;

    e.preventDefault();

    const els = getSectionEls(section);
    openDrawer(els);

    const path = hotspot.getAttribute("data-path");
    setTimeout(() => renderProductIntoDrawer(section, path), 80);
  });

  // Press linger
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".stl__btnPrimary, .stl__btnSecondary, .stl__miniBtn");
    if (!btn) return;
    btn.classList.add("is-pressed");
    setTimeout(() => btn.classList.remove("is-pressed"), 140);
  });

  // ESC closes any open drawer
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    document.querySelectorAll(".stl").forEach((section) => {
      const els = getSectionEls(section);
      if (els.drawer && els.drawer.classList.contains("is-open")) closeDrawer(els);
    });
  });

  // Initial bind + rebind if Builder replaces DOM
  function boot() { bind(); }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  const mo = new MutationObserver(() => bind());
  mo.observe(document.documentElement, { childList: true, subtree: true });

  /**
   * Optional: if language changes client-side (JS integration),
   * refresh links/colors in case anything re-rendered.
   * (No harm if not available in your Weglot mode.)
   */
  try {
    if (window.Weglot && window.Weglot.on) {
      window.Weglot.on("languageChanged", function () {
        bind();
      });
    }
  } catch (e) {}
})();
